<mat-dialog-content class="mat-typography">
    Confermi l&#39;eliminazione del Servizio?
</mat-dialog-content>
<mat-dialog-actions>
    <div class="row justify-content-between">
        <div class="col-6">
            <button mat-button mat-dialog-close cdkFocusInitial>
                Annulla
            </button>
        </div>
        <div class="col-5">
            <button mat-button [mat-dialog-close]="true">
                Conferma
            </button>
        </div>
    </div>
</mat-dialog-actions>